import {unsubscribeReason} from './UnsubscribeReason/en'
import {unsubscribePage} from './UnsubscribePage/en'

export const unsubscribe = {
  ...unsubscribeReason,
  ...unsubscribePage,
}
